import { SVGProps } from 'react';
const SvgArrowLeftRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m16 13 3 3-3 3M5 16h14M8 11 5 8l3-3M19 8H5"
    />
  </svg>
);
export default SvgArrowLeftRight;
